import React, { ComponentType, MouseEventHandler } from 'react'

import { Button, MobileProps, withMobile } from 'component-library-next'

import './index.scss'

type Props = {
  disabled: boolean
  onClick: MouseEventHandler
}

export const EditConfirmationButton: ComponentType<Props> = withMobile(
  ({ disabled, mobile, onClick }: Props & MobileProps) => {
    return (
      <div className='modern-chat-edit-confirmation-button__wrapper'>
        <Button
          testId={'modern-chat-edit-confirmation-button__wrapper'}
          disabled={disabled}
          onClick={onClick}
          size={Button.sizes.standard}
        >
          {mobile ? 'Weiter' : 'Speichern'}
        </Button>
      </div>
    )
  }
)
